var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('section-menu',{attrs:{"name-module":_vm.nameModule,"sections-in-tab":_vm.sectionsInTab}}),_c('b-row',{staticClass:"pt-1"},[_c('b-col',[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }